import { render, staticRenderFns } from "./getInvolvedStatic.vue?vue&type=template&id=3af719c2"
import script from "./getInvolvedStatic.vue?vue&type=script&lang=js"
export * from "./getInvolvedStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports